module.exports = __webpack_public_path__ + "media/images/flags/RS-700df31a15225091da6728a20325886e.svg";